export default {
  meta: {
    title: '菜单管理'
  }
};
